module.exports = __webpack_public_path__ + "img/app_icon_customer.63ba27a1.svg";